import React, { useEffect, useState, useRef } from "react";
import Header from "../Header";
import Loader from "../Utils/Loader";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import {
  Userlogin,
  generatePDFWithTable,
  Toast,
  PasswordPopup,
  fetchDataFromApi,
  shareIphonePostMsg,
} from "../Utils/general-function";
import { useNavigate, Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import callgreenimg from "../../src_img/callgreen.png";
function Leaddata(props) {
  const [List, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedList, setSelectedList] = useState([]);
  const [searchtext, setSearchText] = useState("");
  const [Manualdata, setManualdata] = useState([]);
  const [Saleslist, setSaleslist] = useState([]);
  const prevCountRef = useRef([]);
  const navigate = useNavigate();
  const [input, setInput] = useState({
    startdate: "", // new Date().toLocaleDateString("es-CL"),
    enddate: "", //new Date().toLocaleDateString("es-CL")
  });
  const iphone = window.navigator.userAgent.includes("Mac");
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };
  const Onchange = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    // get sale executive man
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/SalesExecutive/GetSalesExecutiveDetails?dealerrandno=" +
          localStorage.getItem("Ca1itd"),
      )
      .then((res) => {
        console.log("setSaleslist", res);
        setSaleslist(res.data.Data || []);
        setLoading(false);
      })
      .catch((error) => console.log(error));
    OnFilter();
  }, []);

  const dateFormat = "DD/MM/YYYY";

  const fetchlead = async () => {
    // get lead by search text
    setLoading(true);
    try {
      const Leaddata = await fetchDataFromApi(
        "/api/LeadQRCode/LeadQRCodeDetails?searchText=" + searchtext,
      );

      if (
        Leaddata.Message === "Authorization has been denied for this request."
      ) {
        localStorage.clear();
        navigate("/Login");
        return;
      }

      setList(Leaddata.Data);
      setManualdata(Leaddata.Data.filter((d) => !d.Modelyear));
      prevCountRef.current = Leaddata.Data; // for getting prevous data on unchecking of Manual lead
      setLoading(false);
    } catch (error) {
      console.log("Exception found", error);
    }
  };

  // For Date Change Event
  function onDatechange(value, name) {
    setInput((prevInput) => ({
      ...prevInput,
      [name]: value === null ? "" : value.$d.toLocaleDateString("es-CL"),
    }));
  }
  //  For Filtering by Date
  const OnFilter = () => {
    // get leads by date
    setLoading(true);
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    try {
      fetch(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/LeadQRCode/SearchLeadQRCode?date1=" +
          input.startdate +
          "&date2=" +
          input.enddate,
        header,
      )
        .then((response) => response.json())
        .then((res) => {
          setLoading(false);

          if (
            res.Message === "Authorization has been denied for this request."
          ) {
            localStorage.clear();
            navigate("/Login");
            return;
          }

          if (res.Success) {
            setList(res.Data);
            console.log("setList", res);

            prevCountRef.current = res.Data; // for getting prevous data on unchecking of Manual lead
            setManualdata(res.Data.filter((d) => !d.Modelyear));
          } else {
            Toast(res.Success, "", res.Message);
          }
        });
    } catch (error) {
      console.log("Exception found");
    }
  };
  //  For Deleting lead
  const onDelete = (rand) => {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/LeadQRCode/Delete?Rand=" +
        rand,
      header,
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.Success) {
          setList(List.filter((item) => item.Rand !== rand));
        }
      });
  };
  //For individual checkbox
  const oncheck = (e, data) => {
    if (e.target.checked) {
      setSelectedList([...selectedList, data]);
    } else {
      setSelectedList(selectedList.filter((item) => item !== data));
    }

    // setSelectedList(selected)
  };
  console.log("selectedList", selectedList);

  const onSelectall = (e, data) => {
    if (e.target.checked) {
      setSelectedList(data);
      var ele = document.getElementsByName("option1");
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type === "checkbox") ele[i].checked = true;
      }
    } else {
      setSelectedList([]);
      var el = document.getElementsByName("option1");
      for (var k = 0; k < el.length; k++) {
        if (el[k].type === "checkbox") el[k].checked = false;
      }
    }
    // setSelectedList(selected)
  };

  const onshowmanuallead = (e) => {
    if (e.target.checked) {
      setList(Manualdata);
    } else {
      setList(prevCountRef.current);
    }
  };

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}

      <div className="page-space">
        <div className="leadsearchbox">
          {/*--------------------------Search bar -------------------------------*/}
          <div>
            <div className="car-searchbar">
              <input
                type="text"
                placeholder="search here..."
                onChange={Onchange}
              />
              <button onClick={() => fetchlead()}>
                <img src="assets/images/search-icon.png" alt="" />
              </button>
            </div>
          </div>
          {/*------------------------- Date Filter section -----------------------*/}
          <div
            className="car-searchbar d-flex"
            style={{ flexDirection: "column" }}
          >
            <div className="col-12">
              <div className="row g-2 ">
                <div className="col-6">
                  <label>From</label>
                  <DatePicker
                    onChange={(e) => onDatechange(e, "startdate")}
                    format={dateFormat}
                    className="w-100"
                    name="startdate"
                    inputReadOnly={true}
                    maxDate={dayjs(
                      new Date().toLocaleDateString("es-CL"),
                      dateFormat,
                    )}
                  />
                </div>
                <div className="col-6">
                  <label>To</label>
                  <DatePicker
                    onChange={(e) => onDatechange(e, "enddate")}
                    format={dateFormat}
                    className="w-100"
                    name="enddate"
                    inputReadOnly={true}
                    minDate={dayjs(input.startdate, dateFormat)}
                    maxDate={dayjs(
                      new Date().toLocaleDateString("es-CL"),
                      dateFormat,
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 text-center pt-3">
              <button
                type="submit"
                className="submitbtn"
                style={{
                  padding: "5px 18px 7px 18px",
                  fontSize: "14px",
                  backgroundColor: "red",
                }}
                onClick={(e) => OnFilter()}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {/*-------------------------- Lead List-------------------------------- */}
        {List.length !== 0 ? (
          <div className="col-12 text-end pb-3">
            <button
              type="submit"
              className="submitbtn"
              style={{ fontSize: "14px" }}
              onClick={(e) => generatePDFWithTable([...selectedList])}
            >
              Download
            </button>
          </div>
        ) : (
          ""
        )}
        <div className="list-div">
          {List.length === 0 ? (
            <h3 className="text-center m-0 py-3" style={{ color: "#ff002a" }}>
              No Records Available
            </h3>
          ) : (
            <>
              {/*----------------------- Select Checkbox-------------------------------- */}
              <div className="d-flex justify-content-center">
                <div className="form-check-inline m-2 d-inline-flex">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{ marginTop: "5px" }}
                    id="all"
                    name="option2"
                    onChange={(e) => onSelectall(e, List)}
                  />
                  <label
                    className="form-check-label ps-2"
                    style={{ fontSize: "14px" }}
                    htmlFor="all"
                  >
                    Select all for download
                  </label>
                </div>

                <div className="form-check-inline m-2 d-inline-flex">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{ marginTop: "5px" }}
                    id="allManual"
                    name="option2"
                    onChange={(e) => onshowmanuallead(e)}
                  />
                  <label
                    className="form-check-label ps-2"
                    style={{ fontSize: "14px" }}
                    htmlFor="allManual"
                  >
                    Show all Lead manual
                  </label>
                </div>
              </div>
              {/*--------------------------List-------------------------------------------- */}
              {List.map((data, index) => (
                <div className="list-cardiv list-carbottomspace" key={index}>
                  <div className="d-flex justify-content-between">
                    <div className="form-check-inline">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ marginTop: "5px" }}
                        id={data.Rand}
                        name="option1"
                        onChange={(e) => oncheck(e, data)}
                      />
                      <label
                        className="form-check-label ps-2"
                        style={{ fontSize: "14px" }}
                        htmlFor={data.Rand}
                      >
                        {data.Modelyear ? (
                          <h3>
                            {data.Modelyear} {data.carname} {data.variantname}
                          </h3>
                        ) : (
                          <h3>Manual Lead</h3>
                        )}
                      </label>
                    </div>
                    {/* --------------------Icon list for Wp,Edit & Delete---------------------*/}
                    <IconLine
                      data={data}
                      deletemethod={() =>
                        PasswordPopup({
                          method: () => onDelete(data.Rand),
                        })
                      }
                      fetchlead={OnFilter}
                    />
                    {/* --------------------End---------------------*/}
                  </div>

                  {/*------------------------------- Actual list---------------------- */}
                  <div className="list-grid">
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/calender-svg.svg" alt="" />
                        </span>
                        <span className="title">{data.createdate}</span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/profile-svg.svg" alt="" />
                        </span>
                        <span className="title">{data.Name}</span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/car-num.svg" alt="" />
                        </span>
                        <span className="title">
                          {data.Carno && data.Carno !== "undefined"
                            ? data.Carno
                            : "-----"}
                        </span>
                      </div>
                    </div>
                    <div className="list-details">
                      <div className="myflex">
                        {iphone ? (
                          <span
                            style={{ color: "#ff002a" }}
                            onClick={() =>
                              shareIphonePostMsg({
                                action: "open_url_linking",
                                url: "tel:" + data.Contactno,
                              })
                            }
                          >
                            {/* <img src="assets/images/call-svg.svg" alt="" /> */}
                            <img src={callgreenimg} alt="" />
                          </span>
                        ) : (
                          <span>
                            <a
                              style={{ color: "#ff002a" }}
                              href={"tel:" + data.Contactno}
                            >
                              {/* <img src="assets/images/call-svg.svg" alt="" /> */}
                              <img src={callgreenimg} alt="" />
                            </a>
                          </span>
                        )}
                        <span className="title">
                          {iphone ? (
                            <span
                              onClick={() =>
                                shareIphonePostMsg({
                                  action: "open_url_linking",
                                  url: "tel:" + data.Contactno,
                                })
                              }
                              style={{ color: "#E62E2D" }}
                            >
                              {" "}
                              {data.Contactno}
                            </span>
                          ) : (
                            <a
                              style={{ color: "#ff002a" }}
                              href={"tel:" + data.Contactno}
                            >
                              {data.Contactno}
                            </a>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  {data.leadModelnamelist && (
                    <div className="list-details mt-2">
                      <div className="myflex align-items-start">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            x="0"
                            y="0"
                            viewBox="0 0 512 512"
                          >
                            <g>
                              <path
                                d="M43.95 355.171h24.153c3.027 29.103 27.694 51.87 57.583 51.87 29.89 0 54.558-22.767 57.585-51.87h145.838c3.027 29.103 27.694 51.87 57.583 51.87 29.888 0 54.556-22.767 57.583-51.87h23.826c19.62 0 35.444-15.801 35.444-35.444 0-12.439-2.444-24.575-7.263-36.076a92.632 92.632 0 0 0-19.023-28.751c-30.448-31.497-54.735-18.262-73.834-48.594l-33.302-52.799c-19.176-30.401-52.082-48.547-88.026-48.547H196.38c-38.185 0-73.231 20.875-91.458 54.481l-23.39 43.108c-13.402 24.754-36.594 26.341-50.006 32.932-34.127 12.871-19.272 54.774-22.692 84.576 0 19.362 15.754 35.114 35.116 35.114zm81.737 39.804c-25.273 0-45.835-20.564-45.835-45.837s20.562-45.837 45.835-45.837c25.275 0 45.837 20.564 45.837 45.837s-20.562 45.837-45.837 45.837zm261.005 0c-25.273 0-45.835-20.564-45.835-45.837s20.562-45.837 45.835-45.837 45.835 20.564 45.835 45.837-20.562 45.837-45.835 45.837zm83.521-129.848a81.188 81.188 0 0 1 10.774 14.828h-36.603c-4.072 0-7.386-3.337-7.386-7.442a7.28 7.28 0 0 1 2.182-5.213 7.32 7.32 0 0 1 5.204-2.173zM35.782 246.774c12.111-6.089 40.311-8.814 56.357-38.48l23.388-43.103c16.117-29.708 47.098-48.166 80.853-48.166h85.717c31.775 0 60.868 16.044 77.822 42.92l33.3 52.794c19.173 30.458 38.855 23.44 63.259 40.323h-12.094c-5.185 0-10.065 2.031-13.69 5.661-3.662 3.582-5.762 8.607-5.762 13.791 0 10.756 8.727 19.508 19.452 19.508h42.114c3.242 8.908 4.982 18.195 4.982 27.705a23.313 23.313 0 0 1-23.378 23.378h-23.826c-3.027-29.103-27.694-51.87-57.583-51.87-29.888 0-54.556 22.767-57.583 51.87H183.272c-3.027-29.103-27.695-51.87-57.585-51.87-29.888 0-54.556 22.767-57.583 51.87H43.95c-12.71 0-23.051-10.341-23.051-23.048v-33.964h15.04a6.033 6.033 0 1 0 0-12.066H20.9v-5.675c0-9.55 5.981-18.222 14.882-21.578z"
                                fill="#000000"
                                opacity="1"
                                data-original="#000000"
                              ></path>
                              <path
                                d="M121.393 221.718H361.243a6.024 6.024 0 0 0 5.281-3.12 6.03 6.03 0 0 0-.177-6.132l-24.849-39.413c-14.991-23.788-40.73-37.989-68.848-37.989H206.8a81.304 81.304 0 0 0-71.553 42.613l-17.948 33.121c-.217.401-.46.787-.7 1.169l-.351.566a6.032 6.032 0 0 0 5.145 9.185zm209.896-42.232 19.018 30.165H250.093v-62.522h22.558c23.948 0 45.87 12.094 58.638 32.357zm-185.432 3.94a69.253 69.253 0 0 1 60.943-36.297h31.226v62.522H131.644zM289.169 238.832h-24.705a6.033 6.033 0 1 0 0 12.066h24.705a6.033 6.033 0 1 0 0-12.066zM162.495 238.832H137.79a6.033 6.033 0 1 0 0 12.066h24.705a6.033 6.033 0 1 0 0-12.066zM386.695 318.619c-16.829 0-30.519 13.692-30.519 30.519s13.69 30.514 30.519 30.514c16.827 0 30.514-13.688 30.514-30.514s-13.688-30.519-30.514-30.519zm0 48.967c-10.174 0-18.453-8.277-18.453-18.448 0-10.176 8.279-18.453 18.453-18.453 10.171 0 18.448 8.277 18.448 18.453 0 10.171-8.277 18.448-18.448 18.448zM125.689 318.619c-16.827 0-30.516 13.692-30.516 30.519s13.69 30.514 30.516 30.514 30.514-13.688 30.514-30.514-13.687-30.519-30.514-30.519zm0 48.967c-10.174 0-18.45-8.277-18.45-18.448 0-10.176 8.277-18.453 18.45-18.453 10.171 0 18.448 8.277 18.448 18.453 0 10.171-8.277 18.448-18.448 18.448z"
                                fill="#000000"
                                opacity="1"
                                data-original="#000000"
                              ></path>
                            </g>
                          </svg>
                        </span>
                        <span className="title" style={{ fontSize: "12px" }}>
                          {data.leadModelnamelist}
                        </span>
                      </div>
                    </div>
                  )}
                  {/*------------------------For Edit remark--------------------------*/}
                  {data.nRemarks && (
                    <div className="list-details mt-1">
                      <div className="myflex">
                        <span>
                          <img src="assets/images/info-svg.svg" alt="" />
                        </span>
                        <span className="title" style={{ fontWeight: "500" }}>
                          {data.nRemarks}
                        </span>
                      </div>
                    </div>
                  )}

                  <SalesExexutive
                    data={data}
                    salesmanlist={Saleslist}
                    fetchlead={OnFilter}
                  />
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Leaddata;

//------------------- IconLine:- For whatsapp,Edit And Delete Lead-------------------//
export const IconLine = ({ data, deletemethod, fetchlead }) => {
  const onWhatsapp = (value) => {
    const iphone = window.navigator.userAgent.includes("Mac");
    if (iphone) {
      // window.location.href = `https://wa.me/+91${value}`;
      shareIphonePostMsg({
        action: "open_url_linking",
        url: `https://wa.me/+91${value}`,
      });
    } else {
      window.location.href = `intent://send?phone=+91${value}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`;
    }
  };
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };

  const onEdit = (id, data) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        let value = data;

        return (
          <div className="popup-overlay px-3 py-3">
            <div className="form-div">
              <label className="form-label">Remark</label>
              <input
                type="text"
                className="form-control"
                name="remark"
                defaultValue={data}
                onChange={(e) => {
                  value = e.target.value;
                }}
              />

              {/* <span className="text-danger">{errors.name}</span> */}
            </div>
            <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                Editremark(id, value);
                onClose();
              }}
            >
              Submit
            </button>
          </div>
        );
      },
    });
  };

  function Editremark(random, remark) {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/LeadQRCode/editLeadQRCodeRemarks?leadrand=" +
        random +
        "&nRemarks=" +
        remark,
      header,
    )
      .then((response) => response.json())
      .then((res) => {
        Toast(res.Success, res.Message, res.Message);
        fetchlead();
      });
  }

  return (
    <div className="d-flex" style={{ columnGap: "8px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="100%"
        viewBox="0 0 496 496"
        onClick={() => onWhatsapp(data.Contactno)}
      >
        <g transform="matrix(0.9,0,0,0.9,24.799999999999955,24.799999999999955)">
          <path
            d="M321.824 276.528c-.88-1.424-3.168-2.304-6.608-4.016-3.456-1.68-20.48-10-23.632-11.152-1.376-.496-2.592-.896-3.712-.896-1.472 0-2.784.672-4.08 2.608-2.304 3.44-8.944 11.152-10.944 13.456-1.136 1.312-2.304 1.968-3.712 1.968-1.056 0-2.288-.368-3.76-1.12-3.488-1.68-14.624-5.328-27.824-16.992-10.272-9.104-17.216-20.336-19.248-23.776-2.016-3.408-.208-5.28 1.536-6.976 1.552-1.584 3.44-4.032 5.2-6.032 1.728-2 2.304-3.424 3.44-5.712 1.136-2.288.576-4.304-.304-6.016-.848-1.712-7.76-18.592-10.672-25.472-2.144-5.12-4.304-5.776-6.096-5.776-.608 0-1.184.08-1.696.08-1.984 0-4.272-.304-6.608-.304-2.304 0-6.032.864-9.216 4.32-3.152 3.408-12.112 11.712-12.112 28.592 0 16.896 12.384 33.184 14.144 35.472 1.712 2.304 23.92 38.064 59.056 51.808 20.368 7.968 28.944 9.776 33.776 9.776 3.52 0 5.056-.96 7.728-1.2 6.32-.56 20.448-8.32 23.344-16.32 2.88-8 2.88-14.896 2-16.32z"
            fill="#14b617"
            opacity="1"
            data-original="#000000"
          ></path>
          <path
            d="M362.944 0H133.056C60.928 0 0 60.944 0 133.056v229.872C0 435.056 60.928 496 133.056 496h229.888C435.056 496 496 435.056 496 362.912V133.056C496 60.944 435.072 0 362.944 0zM464 362.912c0 54.784-46.272 101.072-101.056 101.072H133.056C78.288 463.984 32 417.712 32 362.912V133.056C32 78.288 78.288 32 133.056 32h229.888C417.712 32 464 78.272 464 133.056v229.856z"
            fill="#14b617"
            opacity="1"
            data-original="#000000"
          ></path>
          <path
            d="M250.608 88.32c-86.592 0-157.04 69.968-157.04 155.984 0 25.936 6.448 51.36 18.736 73.968l-23.12 68.256a16.003 16.003 0 0 0 3.728 16.336c3.056 3.136 7.2 4.8 11.424 4.8 1.616 0 3.248-.24 4.848-.752l71.76-22.784c21.52 10.56 45.456 16.128 69.664 16.128 86.608 0 157.072-69.952 157.072-155.952 0-86.016-70.464-155.984-157.072-155.984zm-.032 279.952c-21.184 0-42.096-5.328-60.464-15.424a16.054 16.054 0 0 0-12.56-1.216L129.6 366.848l15.296-45.12c1.52-4.48.976-9.424-1.488-13.472-11.696-19.2-17.872-41.312-17.872-63.936 0-68.352 56.096-123.984 125.04-123.984 68.96 0 125.072 55.632 125.072 123.984 0 68.336-56.096 123.952-125.072 123.952z"
            fill="#14b617"
            opacity="1"
            data-original="#000000"
          ></path>
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22px"
        height="100%"
        viewBox="0 1 24 24"
        onClick={() => onEdit(data.Rand, data.nRemarks)}
      >
        <g
          fill="none"
          stroke="#ff1237"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        >
          <path d="M9.533 11.15A1.823 1.823 0 0 0 9 12.438V15h2.578c.483 0 .947-.192 1.289-.534l7.6-7.604a1.822 1.822 0 0 0 0-2.577l-.751-.751a1.822 1.822 0 0 0-2.578 0z" />
          <path d="M21 12c0 4.243 0 6.364-1.318 7.682C18.364 21 16.242 21 12 21c-4.243 0-6.364 0-7.682-1.318C3 18.364 3 16.242 3 12c0-4.243 0-6.364 1.318-7.682C5.636 3 7.758 3 12 3" />
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22px"
        height="100%"
        viewBox="2 0 21 26"
        onClick={() => deletemethod()}
      >
        <path
          fill="#ff1237"
          d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6zM8 9h8v10H8zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
        />
      </svg>
    </div>
  );
};

//--------------------SalesExecutive:- for show and edit sales Executive------------//
export const SalesExexutive = ({ data, salesmanlist, fetchlead }) => {
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };

  const onEdit = (id, data) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        let value = data;

        return (
          <div className="popup-overlay px-3 py-3">
            <div className="form-div">
              <label className="form-label">Sales executive</label>
              <select
                className="form-select form-control"
                name="salesman"
                defaultValue={value}
                onChange={(e) => {
                  value = e.target.value;
                }}
              >
                <option value="" disable="disable">
                  Select...
                </option>
                {salesmanlist.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.Name}
                  </option>
                ))}
              </select>
              {/* <span className="text-danger">{errors.salesman}</span> */}
            </div>
            <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                EditExecutive(id, value);
                onClose();
              }}
            >
              Submit
            </button>
            {/* <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button> */}
          </div>
        );
      },
    });
  };

  function EditExecutive(random, salesid) {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/LeadQRCode/editLeadQRCodeSalesexecutive?leadrand=" +
        random +
        "&salesexecutiveId=" +
        salesid,
      header,
    )
      .then((response) => response.json())
      .then((res) => {
        Toast(res.Success, res.Message, res.Message);
        fetchlead();
      });
  }

  return (
    <div
      className="leadby-name"
      onClick={() =>
        PasswordPopup({
          method: () => onEdit(data.Rand, data.salesexecutiveId),
          message: "To edit this record, we require your account password.",
        })
      }
    >
      {data.SalesExecutiveName
        ? "Lead By :" + data.SalesExecutiveName
        : "Assign lead"}
      &nbsp;|&nbsp;
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 64 64"
        >
          <g>
            <path
              d="m63.121 39.879-3-3c-1.133-1.133-3.109-1.133-4.242 0L38.881 53.877a2.965 2.965 0 0 0-.563.779.956.956 0 0 0-.069.18l-2.211 7.895a.998.998 0 0 0 1.232 1.232l7.895-2.211a1.03 1.03 0 0 0 .18-.069c.291-.146.554-.336.777-.562l17-17a3.003 3.003 0 0 0-.001-4.242zM39.908 56.322l3.77 3.77-5.235 1.466zM45.414 59 41 54.586 54.586 41 59 45.414zm16.293-16.293L60.414 44 56 39.586l1.293-1.293a1.025 1.025 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414zM17 39v2c0 2.757 2.243 5 5 5h18c2.757 0 5-2.243 5-5v-2c0-4.759-3.715-8.656-8.396-8.97A8.98 8.98 0 0 0 40 23c0-4.963-4.037-9-9-9s-9 4.037-9 9a8.98 8.98 0 0 0 3.396 7.03C20.715 30.344 17 34.241 17 39zm7-16c0-3.859 3.141-7 7-7s7 3.141 7 7-3.141 7-7 7-7-3.141-7-7zm2 9h10c3.859 0 7 3.141 7 7v2c0 1.654-1.346 3-3 3H22c-1.654 0-3-1.346-3-3v-2c0-3.859 3.141-7 7-7z"
              fill="#000000"
              opacity="1"
              data-original="#000000"
            ></path>
            <path
              d="M55.575 35.564a.995.995 0 0 0 1.133-.846C56.904 33.366 57 32.15 57 31 57 16.663 45.337 5 31 5S5 16.663 5 31s11.663 26 26 26a26.07 26.07 0 0 0 5.19-.54.998.998 0 0 0 .78-1.179.998.998 0 0 0-1.179-.78A24.099 24.099 0 0 1 31 55C17.767 55 7 44.233 7 31S17.767 7 31 7s24 10.767 24 24c0 1.053-.089 2.176-.271 3.432a.998.998 0 0 0 .846 1.132z"
              fill="#000000"
              opacity="1"
              data-original="#000000"
            ></path>
            <path
              d="M34.386 59.798A28.787 28.787 0 0 1 31 60C15.01 60 2 46.99 2 31S15.01 2 31 2s29 13.01 29 29c0 1.216-.081 2.461-.24 3.699a1 1 0 0 0 .864 1.12.991.991 0 0 0 1.12-.864c.17-1.323.256-2.654.256-3.955C62 13.906 48.094 0 31 0S0 13.906 0 31s13.906 31 31 31c1.198 0 2.417-.072 3.622-.216.549-.065.94-.563.875-1.111s-.558-.946-1.111-.875z"
              fill="#000000"
              opacity="1"
              data-original="#000000"
            ></path>
          </g>
        </svg>
      </span>
    </div>
  );
};
